const E164 = /^\+[1-9]\d{7,14}$/;
const NANP_COUNTRIES = ['US', 'CA', 'PR'];

export const isE164 = (value) => E164.test(String(value || ''));

// Converts what an agent typed into E.164 (+15551234567). US/Canada/Puerto Rico
// numbers may be typed without the country code; everything else needs a leading +.
export function normalizePhoneE164(raw, country) {
  const typed = String(raw || '').trim();
  if (!typed) return '';
  const digits = typed.replace(/\D/g, '');
  if (typed.startsWith('+')) return `+${digits}`;
  if (typed.startsWith('00')) return `+${digits.slice(2)}`;
  if (NANP_COUNTRIES.includes(country) || !country) {
    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  }
  return typed;
}
